import type ConfigService from '../../../../../config/ConfigService';
import { container } from '../../../../../inversify.config';
import { TOKEN } from '../../../../../inversify.tokens';
import type { NoiseSuppressorParams } from '../../../../../types/streamEffects';

export default class NoiseSuppressionAudioWorkletNode extends AudioWorkletNode {
  constructor(params: NoiseSuppressorParams) {
    super(params.context, 'rnnoise', {
      channelCountMode: 'explicit',
      channelCount: 1,
      channelInterpretation: 'speakers',
      numberOfInputs: 1,
      numberOfOutputs: 1,
      outputChannelCount: [1],
      processorOptions: {
        module: params.noiseSuppressor.module,
      },
    });

    this.port.onmessage = ({ data }) => {
      const e: Event = Object.assign(new Event('status'), data);
      this.dispatchEvent(e);
    };
  }

  update(keepalive: boolean): void {
    this.port.postMessage(keepalive);
  }

  static async register(context: AudioContext): Promise<void> {
    // TODO: refactor after TT-187 merge (audio effects)
    const config = container.get<ConfigService>(TOKEN.Config);
    await context.audioWorklet.addModule(`${ config.get('staticFilesPath') }/noiseSuppressionWorklet.js`);
  }
}
